import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { BASE_URL } from '../apiConfig';

export const fetchMasterData = createAsyncThunk(
    'master/fetchData',
    async ({ jwtBearer, field }) => {
        const response = await fetch(`${BASE_URL}master/data/?field=${field}`, {
            headers: {
                Authorization: `Bearer ${jwtBearer}` 
            }
        });
        const data = await response.json();
        return { field, data }; 
    }
);

const masterSlice = createSlice({
    name: 'masterSlice',
    initialState: {
        designations: [],
        form_user_ids: [],
        esi_users: [],    
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchMasterData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMasterData.fulfilled, (state, action) => {
                state.loading = false;
                switch (action.payload.field) {
                    case 'designation':
                        state.designations = action.payload.data;
                        break;
                    case 'form_user_id':
                        state.form_user_ids = action.payload.data;
                        // console.log("state.form_user_ids",state.form_user_ids)
                        break;
                    case 'esi_users':
                        state.esi_users = action.payload.data;
                        break;
                    default:
                        break;
                }
            })
            .addCase(fetchMasterData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default masterSlice.reducer;